import React, { useState, useEffect } from 'react';

//css
import './DigitalPriceTag.css';

//Ui
import Button from '../../components/button';
import CustomPaginationTable from '../../components/table/CustomPaginationTable';
import AddUploadForm from '../../components/customForm/AddUploadForm';
import AddIcon from '../../static/image/addIcon.svg';
import DeleteIcon from '../../static/image/deleteIcon.svg';

//redux
import { useDispatch, useSelector } from 'react-redux';
import { getListAllDistData, uploadExcel, updateDigitalPriceTagData } from '../../redux/digitalPriceSlice';

//components
import AddUpload from './AddUpload';
import CommonDeleteModal from '../../components/commonDeleteModal/CommonDeleteModal';
import CommonSuccessModal from '../../components/commonSuccessModal/CommonSuccessModal';
import { decodedJWTPayload } from '../../utils/commonUtil';
import { formatDatetime } from '../../utils/dateUtils';

//constants
import { UPLOAD_EXCEL_SUCCESS, UPLOAD_EXCEL_FAIL, RED, YELLOW, BLACK } from "../../utils/constant";

function UploadExcelRoadShow() {

  const dispatch = useDispatch();
  const { resdata, totalElements, error, loading } = useSelector((state) => state.digitalPrice);

  const getRowClass = (row) => {
    if (row.isError) {
      return "error-msg";
    } else if (!row.isError && row.messageText) {
      return "error-msg-orange";
    }
    return "non-error-msg";
  };

  const columns = [
    {
      name: 'Record ID',
      cell: (row, index) => (
        <div className={getRowClass(row)}>{row.discountDataId}</div>
      ),
    },
    {
      name: <div>Stock Code</div>,
      cell: (row, index) => (
        <div className={getRowClass(row)}>{row.stockCode}</div>
      ),
    },
    {
      name: <div>Brand Name</div>,
      cell: (row, index) => (
        <div className={getRowClass(row)}>{row.brandName}</div>
      ),
    },
    {
      name: <div>Model Name</div>,
      cell: (row, index) => (
        <div className={getRowClass(row)}>{row.modelName}</div>
      ),
    },
    {
      name: 'Discount',
      cell: (row, index) => (
        <div className={getRowClass(row)}>
          {row.discountAmount !== null && row.discountAmount !== undefined
            ? parseFloat(row.discountAmount).toFixed(2)
            : ''}
        </div>
      ),
    },
    {
      name: <div>Promo RRP</div>,
      cell: (row, index) => (
        <div className={getRowClass(row)}>
          {row.promoRrp !== null && row.promoRrp !== undefined
            ? parseFloat(row.promoRrp).toFixed(2)
            : ''}
        </div>
      ),
    },
    {
      name: <div>Promo Start Date</div>,
      cell: (row, index) => (
        <div className={getRowClass(row)}>
          {row.periodStart ? row.periodStart.substring(0, 10) : null}
        </div>
      ),
    },
    {
      name: <div>Promo End Date</div>,
      cell: (row, index) => (
        <div className={getRowClass(row)}>
          {row.periodEnd ? row.periodEnd.substring(0, 10) : null}
        </div>
      ),
    },
    {
      name: <div>Freebies</div>,
      cell: (row, index) => (
        <div className={getRowClass(row)}>
          {row.freebies}
        </div>
      ),
    },
    {
      name: <div>Uploaded By</div>,
      cell: (row, index) => (
        <div className={getRowClass(row)}>
          {row.createdBy}
        </div>
      ),
    },
    {
      name: <div>Uploaded Date Time</div>,
      cell: (row, index) => (
        <div className={getRowClass(row)}>{formatDatetime(row.updatedDatetime)}</div>
      ),
    },
    {
      name: 'Message',
      cell: (row, index) => (
        <div className={getRowClass(row)}>{row.messageText}</div>
      ),
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div style={{ display: 'flex', gap: '10px', cursor: shouldDisableDelete ? 'default' : 'pointer' }}>
          <img
            src={DeleteIcon}
            alt="Delete"
            onClick={() => handleDeleteClick(row)}
            style={{ opacity: shouldDisableDelete ? 0.5 : 1, pointerEvents: shouldDisableDelete ? 'none' : 'auto' }}
          />
        </div>
      ),
      sortable: false
    }
  ];

  const [isAddUploadOpen, setIsAddUploadOpen] = useState(false);
  const [uploadErr, setUploadErr] = useState(undefined);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [successModalMessage, setSuccessModalMessage] = useState('');
  const [successModalStatus, setSuccessModalStatus] = useState('');
  const [shouldDisableUpload, setShouldDisableUpload] = useState(false);
  const [shouldDisableDelete, setShouldDisableDelete] = useState(false);
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10
  });
  const [searchParams, setSearchParams] = useState({
    sku: '',
    promoDate: null
  });
  const [shouldSearch, setShouldSearch] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      const payload = decodedJWTPayload(token);
      const mnId = payload?.mn_id;

      if (mnId) {
        const match = mnId.match(/\|030200-([RW]+)\|/);
        if (match) {
          const permission = match[1];
          if (permission === 'R') {
            setShouldDisableUpload(true);
            setShouldDisableDelete(true);
          } else if (permission === 'RW') {
            setShouldDisableDelete(true);
            setShouldDisableUpload(false);
          }
        }
      }
    }
  }, []);


  useEffect(() => {
    setShouldSearch(true);
  }, []);


  useEffect(() => {
    if (shouldSearch) {
      const formattedSearchParams = {
        ...searchParams,
        promoDate: searchParams.promoDate ? formatDate(searchParams.promoDate) : null
      };
      dispatch(getListAllDistData({
        ...pagination,
        discount_type: 1,
        ...formattedSearchParams
      }));
      setShouldSearch(false);
    }
  }, [dispatch, pagination.page, pagination.size, searchParams, shouldSearch]);

  const handleAddUploadClick = () => {
    setIsAddUploadOpen(true);
  };

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (selectedRow) {
      const payload = {
        isActive: selectedRow.isActive,
        discountDataId: selectedRow.discountDataId,
        discountType: 1
      };
      dispatch(updateDigitalPriceTagData(payload))
        .unwrap()
        .then(() => {
          const formattedSearchParams = {
            ...searchParams,
            promoDate: searchParams.promoDate ? formatDate(searchParams.promoDate) : null
          };
          dispatch(getListAllDistData({
            ...pagination,
            discount_type: 1,
            ...formattedSearchParams
          }));
        })
        .catch((error) => {
          console.error('Error updating digital price tag data:', error);
        });
    }
    setShowDeleteModal(false);
  };

  const handleCancel = () => {
    setIsAddUploadOpen(false);
    setUploadErr('');
  };

  const handleUploadErr = err => {
    setUploadErr(err);
  }

  const handlePageChange = (page) => {
    setPagination(prev => ({
      ...prev,
      page: page - 1 // Convert to 0-based index
    }));
    setShouldSearch(true);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPagination({
      page: page - 1,
      size: newPerPage
    });
    setShouldSearch(true);
  };

  const handleUpload = (file) => {
    if (!file) {
      setUploadErr("Please upload file.");
      return;
    }

    const formattedSearchParams = {
      ...searchParams,
      promoDate: searchParams.promoDate ? formatDate(searchParams.promoDate) : null
    };

    dispatch(uploadExcel({ file, discountType: 1 }))
      .unwrap()
      .then(res => {
        if (parseInt(res.status) === 200) {
          setShowModal(true);
          setSuccessModalStatus(true);
          setSuccessModalMessage(UPLOAD_EXCEL_SUCCESS);
          dispatch(getListAllDistData({
            ...pagination,
            discount_type: 1,
            ...formattedSearchParams
          }));
        } else {
          setShowModal(true);
          setSuccessModalStatus(false);
          const errorMessage = error.message;
          setSuccessModalMessage(errorMessage);
        }
      })
      .catch((error) => {
        setShowModal(true);
        setSuccessModalStatus(false);
        const errorMessage = error.message;
        setSuccessModalMessage(errorMessage);
      });

  };

  const handleCloseSuccessModal = () => {
    setShowModal(false);
    setIsAddUploadOpen(false);
  }

  const handleSearch = () => {
    setShouldSearch(true);
  };

  const handleReset = () => {
    setSearchParams({
      sku: '',
      promoDate: null
    });
    setShouldSearch(true);
  };

  const handleSearchParamsChange = (name, value) => {
    setSearchParams(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="manage-user-container">
      {!isAddUploadOpen && (
        <div style={{ padding: '30px' }}>
          Upload Excel (Roadshow)

          <div style={{ display: 'flex', marginTop: '20px', width: '750px', alignItems: 'center' }}>
            <AddUploadForm
              onSearchParamsChange={handleSearchParamsChange}
              searchParams={searchParams}
            />

            <div style={{ marginLeft: 'auto', display: 'flex', marginTop: '35px' }}>
              <Button className='upload-btn' style={{ marginRight: '20px' }} onClick={handleSearch}>
                SEARCH
              </Button>
              <Button className='upload-btn' onClick={handleReset}>
                RESET
              </Button>
            </div>
          </div>

          <div style={{ display: 'flex', marginTop: '20px', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex' }}>
              <Button
                className='upload-add-request-btn'
                onClick={handleAddUploadClick}
                style={{ opacity: shouldDisableUpload ? 0.5 : 1, pointerEvents: shouldDisableUpload ? 'none' : 'auto' }}
              >
                <img src={AddIcon} style={{ marginRight: '5px' }} alt="Add" />
                UPLOAD DISCOUNTED RRP EXCEL
              </Button>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              fontSize: '12px',
              gap: '4px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                  width: '12px',
                  height: '12px',
                  backgroundColor: '#ED1A3D',
                  marginRight: '8px'
                }} />
                <div>{RED}</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                  width: '12px',
                  height: '12px',
                  backgroundColor: '#FFA500',
                  marginRight: '8px'
                }} />
                <div>{YELLOW}</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                  width: '12px',
                  height: '12px',
                  backgroundColor: '#2C2C2C',
                  marginRight: '8px'
                }} />
                <div>{BLACK}</div>
              </div>
            </div>
          </div>



          <div style={{ marginTop: '20px' }}>
            <CustomPaginationTable
              columns={columns}
              data={resdata}
              totalRows={totalElements}
              loading={loading}
              currentPage={pagination.page + 1} // Convert to 1-based index
              perPage={pagination.size}
              onPageChange={handlePageChange}
              onPerRowsChange={handlePerRowsChange}
            />
          </div>
        </div>
      )}

      {
        isAddUploadOpen && <AddUpload
          title={'Upload Excel (Roadshow)'}
          onCancel={handleCancel}
          handleUpload={handleUpload}
          uploadErr={uploadErr}
          handleUploadErr={handleUploadErr}
        />
      }

      <CommonDeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        itemDetails={selectedRow}
      />

      <CommonSuccessModal
        showModal={showModal}
        handleClose={handleCloseSuccessModal}
        message={successModalMessage}
        status={successModalStatus}
      />

    </div>
  );
}

export default UploadExcelRoadShow;
